import axios from 'axios'
import { API_PROYT } from '../../config/config.json'

export async function getConfigurableData(data) {  
  let config = {
    method: 'post',
    url: `${API_PROYT}/getsystemconfiguration`,
    headers: {
      'Content-Type': 'application/json'
    },data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

